<script setup lang='ts'>
const colorMode = useColorMode();

const getNextMode = () => {
	switch (colorMode.preference) {
		case 'light':
			return 'dark';
		case 'dark':
			return 'system';
		case 'system':
		default:
			return 'light';
	}
};

const getIcon = () => {
	switch (colorMode.preference) {
		case 'light':
			return 'i-lucide-sun';
		case 'dark':
			return 'i-lucide-moon';
		case 'system':
		default:
			return 'i-lucide-monitor';
	}
};

const cycleColorMode = () => {
	colorMode.preference = getNextMode();
};
</script>

<template>
	<ClientOnly v-if="!colorMode?.forced">
		<UButton :icon="getIcon()" color="neutral" variant="ghost" @click="cycleColorMode" />
	</ClientOnly>
</template>
